/**
 * Sesión del super-admin en localStorage.
 *
 * Tradeoff conocido: localStorage es vulnerable a XSS. Mitigación:
 *   - El bundle es single-page con el código que controlamos (sin scripts
 *     de terceros injectados).
 *   - El admin solo lo usa el dueño desde un browser confiable.
 *   - Cuando dominio admin + worker compartan raíz, migramos a cookies
 *     httpOnly + SameSite=Strict.
 */

const KEY = 'atreus.admin.session.v1';

export interface AdminSession {
  accessToken: string;
  accessExpiresAt: number;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    role: 'superadmin';
  };
  tenantId: string;
  savedAt: number;
}

export const loadSession = (): AdminSession | null => {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AdminSession;
    if (!parsed.accessToken || !parsed.refreshToken) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveSession = (session: AdminSession): void => {
  window.localStorage.setItem(KEY, JSON.stringify(session));
};

export const clearSession = (): void => {
  window.localStorage.removeItem(KEY);
};
